import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-included',
  templateUrl: './included.component.html',
  styleUrls: ['./included.component.scss']
})
export class IncludedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
